module.exports = __webpack_public_path__ + "static/media/Vault Workgroup.7021ccf5.png";